import { render, staticRenderFns } from "./r-settings-dialog.vue?vue&type=template&id=c7fe5374&scoped=true"
import script from "./r-settings-dialog.vue?vue&type=script&lang=js"
export * from "./r-settings-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-settings-dialog.vue?vue&type=style&index=0&id=c7fe5374&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fe5374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7fe5374')) {
      api.createRecord('c7fe5374', component.options)
    } else {
      api.reload('c7fe5374', component.options)
    }
    module.hot.accept("./r-settings-dialog.vue?vue&type=template&id=c7fe5374&scoped=true", function () {
      api.rerender('c7fe5374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/settings/r-settings-dialog.vue"
export default component.exports